$(function() {

     const $slider = $(".top_slider");
// 左右の透過の2周目ががたつく対応
$slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
  $slider.find(".slick-slide").each((index, el) => {
    const $this = $(el),
      slickindex = $this.attr("data-slick-index");
    if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
      // 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
      if (slickindex == "-1") {
        // 最後のスライドに対してクラスを付与
        $this.addClass("is-active-next");
      } else {
        // それ以外は削除
        $this.removeClass("is-active-next");
      }
    } else if (nextSlide == 0) {
      // 次のスライドが最初のスライドの場合
      if (slickindex == slick.slideCount) {
        // 最初のスライドに対してクラスを付与
        $this.addClass("is-active-next");
      } else {
        // それ以外は削除
        $this.removeClass("is-active-next");
      }
    } else {
      // それ以外は削除
      $this.removeClass("is-active-next");
    }
  });
});

   $slider.slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    centerMode: true,
    centerPadding: '70px',
    slidesToShow: 1,
    arrows: false,
    mobileFirst: true,
    responsive: [
    {
        breakpoint: 576,
        settings: {
        slidesToShow: 3,
        }
    },
    {
        breakpoint: 767,
        settings: {
        slidesToShow: 3,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        variableWidth: true,
        useTransform: false
        }
    },
  ]
});

$(".news_slider").slick({
    centerMode: true,
    centerPadding: '50px',
    slidesToShow: 1,
    arrows: false,
    mobileFirst: true,
    responsive: [
    {
        breakpoint: 576,
        settings: {
        slidesToShow: 3,
        centerPadding: false,
        }
    }
  ]
});
        
        });